import type { MessageId } from '@/assets/lang/en-US';
import type {
  BooleanOperator,
  FieldType,
  MultiSelectOperator,
  NumericOperator,
  ConditionOperator,
} from './types';

/**
 * Root group is depth 1;
 */
export const MAX_DEPTH = 2;

/** Muted outline colour used for the select chevrons and variable-type icons. */
export const SELECT_ICON_COLOR = 'var(--os-mainColor-outline-primary)';

const MULTISELECT_OPERATORS: MultiSelectOperator[] = [
  'is_any_of',
  'is_none_of',
];

export const BOOLEAN_OPERATOR = {
  true: 'is_true',
  false: 'is_false',
} as const satisfies Record<'true' | 'false', BooleanOperator>;

const BOOLEAN_OPERATORS: BooleanOperator[] = [
  BOOLEAN_OPERATOR.true,
  BOOLEAN_OPERATOR.false,
];

const NUMERIC_OPERATORS: NumericOperator[] = ['gte', 'lte'];

export const OPERATORS_BY_FIELD_TYPE: Record<FieldType, ConditionOperator[]> = {
  multiselect: MULTISELECT_OPERATORS,
  boolean: BOOLEAN_OPERATORS,
  numeric: NUMERIC_OPERATORS,
};

export const DEFAULT_OPERATOR_BY_FIELD_TYPE: Record<
  FieldType,
  ConditionOperator
> = {
  multiselect: 'is_any_of',
  boolean: BOOLEAN_OPERATOR.true,
  numeric: 'gte',
};

export const OPERATOR_LABEL_KEYS: Record<ConditionOperator, MessageId> = {
  is_any_of: 'programTable.scopeFilter.operator.isAnyOf',
  is_none_of: 'programTable.scopeFilter.operator.isNoneOf',
  is_true: 'programTable.scopeFilter.operator.isTrue',
  is_false: 'programTable.scopeFilter.operator.isFalse',
  gte: 'programTable.scopeFilter.operator.gte',
  lte: 'programTable.scopeFilter.operator.lte',
};
